import { Component, OnInit, ChangeDetectorRef, ViewContainerRef, ViewChild, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { MessageService } from 'primeng/api';
import { RequisitionDataService } from '../../data-services/requisition.service';
import { RequisitionExceptionDataService } from '../../data-services/requisitionException.service';
import { RackDataService } from '../../data-services/rack.service';
import { MedTek21DataService } from '../../data-services/medtek21.service';
import { SelectItem, ConfirmationService } from 'primeng/api';
import { RequisitionDto } from '../../models/requisition-dto';
import { RequisitionStatusHistoryDataService } from '../../data-services/requisitionStatusHistory.service';
import { RequisitionTestDataService } from '../../data-services/requisitionTest.service';
import { RequisitionStatusHistoryDto } from '../../models/requisition-status-history-dto';
import moment from 'moment';
import { LocalRequistionService } from '../../data-services/local-requisition.service';
import { LookupService } from '../../data-services/lookup.service';
import { LabDataService } from '../../data-services/lab.service';
import { ActiveLabPanelDto } from '../../models/active-panel-dto';
import { CodeDescription } from '../../models/code-description-dto';
import { Gender } from '../../models/gender';
import { Ethnicity } from '../../models/ethnicity';
import { SecurityService } from '../../security/security.service';
import { Race } from '../../models/race';
import { RequisitionIntakeDataService } from '../../data-services/requisitionIntake.service';
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { ListboxModule } from 'primeng/listbox';
import { HasClaimDirective } from '../../security/has-claim.directive';
import { ReceivingEditRequisitionComponent } from './receiving-edit/receiving-edit-requisition.component';
import { RackLocationPipe } from '../../helpers/rackLocation.pipe';
import { ConfigService } from '../../configHelper';

@Component({
  selector: 'app-receiving-sample',
  templateUrl: './receiving.sample.html',
  styleUrls: ['./receiving.sample.css'],
  providers: [MessageService, ConfirmationService],
  imports: [ButtonModule, Dialog, FormsModule, ConfirmDialog, Toast, CommonModule, ListboxModule, HasClaimDirective, ReceivingEditRequisitionComponent, RackLocationPipe]
})
export class ReceivingSampleComponent implements OnInit {
  @Output() onSampleUpdated = new EventEmitter<any>();
  @Output() onSaveRequisition = new EventEmitter<any>();
  constructor(private requisitionService: RequisitionDataService,
    private requisitionExceptionService: RequisitionExceptionDataService,
    private requisitionStatusHistoryService: RequisitionStatusHistoryDataService,
    private requisitionTestService: RequisitionTestDataService,
    private requisitionIntakeService: RequisitionIntakeDataService,
    private rackService: RackDataService,
    private medtek21Service: MedTek21DataService,
    private messageService: MessageService,
    public dialogModule: DialogModule,
    private localReqService: LocalRequistionService,
    private lookupService: LookupService,
    public securityService: SecurityService,
    private configService: ConfigService) {
  }

  @ViewChild('container', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;


  @Input() requisitionId: any = 28;
  @Input() packageDeliveredDate: any;

  loading: boolean = true;
  showRejectDialog: boolean = false;
  showUnrejectDialog: boolean = false;
  showLabelMatchDialog: boolean = false;
  showStatusHistory: boolean = false;
  showTestStatusHistory: boolean = false;
  showResultComment: boolean = false;
  resultIdForComment: number;
  resultComment: string;
  loadingRTSH: boolean = true;
  requisition: RequisitionDto;
  requisitionStatusHistoryList: RequisitionStatusHistoryDto[] = [];
  requisitionTestStatusHistoryList: [];
  requisitionRack: any = {};
  order: any = {};
  rejectionTypes: SelectItem[] = [];
  rejectionComments: SelectItem[] = [];
  selectedRejectionType: any = [];
  rejectionDescription: string = "";
  rejectionSelDescription: string = "";
  unrejectionDescription: string = "";
  orderNotFound: any = "";
  medtekOrder: any = {}
  statusDto: StatusDto;
  reqStatusDate: string;
  reqStatusReceived: string;
  editRequisitionFlag = false;
  disableRequisitionEdit = false;
  labPanelData: ActiveLabPanelDto = null;
  rejectionLevel: any = null;
  rejectRequisitionTestId: number = null;
  canReject: boolean = true;
  canUpdate: boolean = true;

  genderList: CodeDescription[] = [];
  genderDto: Gender;
  genderDescription: string;

  ethnicityList: CodeDescription[] = [];
  ethnicity: Ethnicity;
  ethnicityDescription: string;

  raceList: CodeDescription[] = [];
  race: Race;
  raceDescription: string;

  rejectionCommentRequired: boolean = false;
  rejectionCommentOtherRequired: boolean = false;
  isInterVenn: boolean = false;

  ngOnInit() {
    this.isInterVenn = this.configService.getConfig().isInterVenn;

    this.initReqDto();
    this.initStatusDto();
    this.loadRequisition();
    this.loadRequisitionStatusHistory();

    this.genderDto = new Gender();
    this.genderList = this.genderDto.getGenderListing();

    this.ethnicity = new Ethnicity();
    this.ethnicityList = this.ethnicity.getEthnicityListing();

    this.race = new Race();
    this.raceList = this.race.getRaceListing();

    if (this.isInterVenn) {
      this.rejectionTypes = [
        { label: 'Other', value: '7' }
      ];
      this.selectedRejectionType = [this.rejectionTypes[0].value];
    }
    else {
      this.rejectionTypes = [
        //{ label: 'Rejection', value: '0' },
        { label: 'LIT', value: '1' },
        { label: 'Past Stability', value: '2' },
        { label: 'QNS', value: '3' },
        { label: 'Order Details Missing', value: '4' },
        //{ label: 'Duplicate Serial Number', value: '5' },
        //{ label: 'Mismatched Label', value: '6' },
        { label: 'Other', value: '7' }
      ];
    }

    this.lookupService.getStandardComments('reject').subscribe((data: any) => {
      if (data) {
        this.rejectionComments = [];
        data.forEach(d => {
          this.rejectionComments.push({
            label: d.Comment,
            value: d.Comment
          });
        });

        this.rejectionComments.push({ label: 'Other', value: 'Other' });
        console.log('standard comments', this.rejectionComments);
      }
    });
  }

  public loadRequisition() {
    this.requisitionService.getDetail(this.requisitionId).subscribe((data: any) => {
      this.requisition = data;

      this.genderDescription = this.genderList.find(x => {
        return (x.Code == this.requisition.Gender);
      })?.Description;

      this.ethnicityDescription = this.ethnicityList.find(x => {
        return (x.Code == this.requisition.Ethnicity);
      })?.Description;

      this.raceDescription = this.raceList.find(x => {
        return (x.Code == this.requisition.Race);
      })?.Description;

      this.reqStatusDate = moment(this.requisition.StatusDate).format('MM/DD/YYYY hh:mm:ss A');
      this.reqStatusReceived = moment(this.requisition.DateReceived).format('MM/DD/YYYY hh:mm:ss A');

      if (this.requisition.DateCompleted) {
        this.canUpdate = false;
      }

      console.log('sample', data);
      this.onSampleUpdated.emit(this.requisition);
      this.loading = false;
      this.requisitionRack = null;
      if (this.requisition.HasExceptions) {

        for (var i = 0; i < this.requisition.RequisitionExceptions.length; i++) {
          if (this.requisition.RequisitionExceptions[i].ExceptionType == 1 &&
            !this.requisition.RequisitionExceptions[i].Resolved) {
            this.canReject = false;
          }
        }

        this.rackService.getGetCurrentRackForRequisition(this.requisitionId).subscribe((data: any) => {
          this.requisitionRack = data;
        });
      }
    });
  }

  editRequisition() {
    console.log('set req ', this.requisition);
    this.localReqService.setRequisition(this.requisition);
    this.localReqService.setRequisitionStatusHistoryList(this.requisitionStatusHistoryList);
    this.editRequisitionFlag = true;
    this.disableRequisitionEdit = false;
  }

  sortTestResults(list) {
    return list.sort((n1, n2) => {
      if (n1.ReportDate < n2.ReportDate) return 1;
      if (n1.ReportDate > n2.ReportDate) return -1;
      return 0;
    });
  }

  updateOrder() {
    this.loading = true;
    this.requisitionIntakeService.updateOrder(this.requisition.Accession).subscribe((data: any) => {
      if (data) {
        this.loadRequisition();
      }
    });
  }

  reqRequisitionUpdated() {
    this.editRequisitionFlag = false;
    this.loading = false;
    this.loadRequisition();
    this.messageService.add({ severity: 'success', summary: 'Requisition Updated' });
    this.disableRequisitionEdit = false;
  }
  reqRequisitionUpdateFailed(err) {
    this.messageService.add({ severity: 'error', summary: 'Requisition Update Failed', detail: err });
  }

  cancelEditRequisition() {
    this.editRequisitionFlag = false;
    this.disableRequisitionEdit = false;
  }

  public loadRequisitionStatusHistory() {
    this.requisitionStatusHistoryService.getRequisitionStatusHistoryListById(this.requisitionId).subscribe((data: RequisitionStatusHistoryDto[]) => {
      if (data !== null) {
        this.requisitionStatusHistoryList = data;
        this.createStatusDto();
        console.log('status history', data);
        console.log('status list ', this.statusDto);
      }
      this.loading = false;
    });
  }


  public loadRequisitionTestStatusHistory(id: number) {
    this.showTestStatusHistory = true;
    this.loadingRTSH = true;
    this.requisitionTestService.getStatusHistory(id).subscribe((data: any) => {
      this.requisitionTestStatusHistoryList = data;
      this.loadingRTSH = false;
    });
  }

  public getRequisitionTestResultReport(id: number) {
    this.requisitionTestService.getTestResultReport(id).subscribe((response: any) => {
      if (response) {
        let file = new Blob([response], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
      else
      {
        this.messageService.add({ severity: 'error', summary: 'PDF is not available' });
      }
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Unable to retrieve Report PDF ', detail: 'Failed: ' + err.error });
    });
  }

  public getRequisitionTestRejectReport(id: number) {
    this.requisitionTestService.getTestRejectReport(id).subscribe((response: any) => {
      if (response) {
        let file = new Blob([response], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Unable to retrieve Report PDF ', detail: 'Failed: ' + err.error });
    });
  }

  isAdmin(): boolean {
    return this.securityService.hasClaim('LabAdmin_Edit');
  }

  private createStatusDto() {
    this.requisitionStatusHistoryList.forEach(status => {
      let statusdatetime = moment(status.StatusDate).format('MM/DD/YYYY hh:mm:ss A');
      switch (status.Status) {
        case 'Sent':
          this.statusDto.sentDate = statusdatetime;
          break;
        case 'Pending':
          this.statusDto.pendingDate = statusdatetime;
          break;
        case 'Received':
          this.statusDto.receivedDate = statusdatetime;
          break;
        case 'Processing':
          this.statusDto.processingDate = statusdatetime;
          break;
        case 'Reporting':
          this.statusDto.reportingDate = statusdatetime;
          break;
        case 'Resulted':
          this.statusDto.resultedDate = statusdatetime;
          break;
        case 'Completed':
          this.statusDto.completedDateArr.push(statusdatetime);
          break;
        case 'Rejected':
          this.statusDto.rejectedDateArr.push(statusdatetime);
          break;
        default:
          break;
      }
    });
  }

  public attemptToResolveRequisitionExceptions() {
    this.loading = true;
    if (this.requisition === null) return;

    if (this.isInterVenn) {
      for (var i = 0; i < this.requisition.RequisitionExceptions.length; i++) {
        var exc = this.requisition.RequisitionExceptions[i];
        this.requisitionExceptionService.ResolveRequisitionException(exc.Id).subscribe((data: any) => {
          this.requisition.RequisitionExceptions[i] = data;
          this.loadRequisition();
        },
          (err) => {
            if (err.error.ExceptionMessage !== undefined) {
              this.messageService.add({ severity: 'error', summary: `Attempt to Resolve Requisition Exceptions: ${this.requisition.Accession} - ${err.error.ExceptionMessage}`, detail: `Error: ${err.status}` });
            }

            this.loadRequisition();
          });
      }
    }
    else {
      this.requisitionService.attemptToResolveRequisitionExceptions(this.requisition.Accession).subscribe((data: any) => {
        var index = this.requisition.RequisitionExceptions.findIndex(obj => obj.Id == data.Id);
        this.requisition.RequisitionExceptions[index] = data;
        this.loadRequisition();
      },
        (err) => {
          if (err.error.ExceptionMessage !== undefined) {
            this.messageService.add({ severity: 'error', summary: `Attempt to Resolve Requisition Exceptions: ${this.requisition.Accession} - ${err.error.ExceptionMessage}`, detail: `Error: ${err.status}` });
          }
        
          this.loadRequisition();
        });
    }


  }

  public resolveLabelMismatchException() {
    if (this.requisition === null) return;
    console.log('Accession:' + this.requisition.Accession);
    console.log(this.requisition);

    this.requisitionService.getMTOrder(this.requisition.Accession).subscribe((data: any) => {
      this.medtekOrder = data;
      this.showLabelMatchDialog = true;
    },
      (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Unable to retrieve order from Medtek21',
          detail: 'Error: ' + err.status
        });
      });
  }

  public confirmLabelMatch() {
    if (this.requisition === null) return;
    var labelMismatchEx = this.requisition.RequisitionExceptions.find(e => e.ExceptionType == 4);
    this.requisitionExceptionService.ResolveLabelMismatch(labelMismatchEx.Id).subscribe((data: any) => {
      labelMismatchEx.Resolved = true;
      this.requisition = data;
    },
      (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error resolving label mismatch exception',
          detail: 'Error: ' + err.status
        });
      });
    this.showLabelMatchDialog = false;
  }
  public cancelLabelMatch() {
    this.showLabelMatchDialog = false;
  }

  public sendRequisitionToIntegrations() {
    this.loading = true;
    if (this.requisition === null) return;
    this.requisitionService.sendRequisitionToIntegrations(this.requisition.Accession, true).subscribe((data: boolean) => {
      this.messageService.add({ severity: 'success', summary: 'Integrations ' + this.requisition.Accession, detail: `Integrations were successful` });
      this.loadRequisition();
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Integrations ' + 'At least one integration failed: ' + this.requisition.Accession, detail: err.error });
      this.loadRequisition();
    });
  }

  public deleteRequisition() {
    this.loading = true;
    if (this.requisition === null) return;
    this.requisitionService.deleteRequisition(this.requisition.Id).subscribe((data: boolean) => {
      this.messageService.add({ severity: 'success', summary: 'Delete ' + this.requisition.Accession, detail: `Delete was successful` });
      this.requisition = null;
      this.requisitionRack = {};
      this.loading = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Delete ' + this.requisition.Accession, detail: err.error });
      this.loading = false;
    });
  }

  public displayRejectDialog(type, reqTestId) {
    this.rejectionLevel = type;
    this.rejectRequisitionTestId = reqTestId;
    this.showRejectDialog = true;
  }

  public rejectRequisition() {
    this.showRejectDialog = false;
    this.loading = true;
    console.log("rejecting");
    if (this.isInterVenn) {
      this.selectedRejectionType = [this.rejectionTypes[0].value];
      console.log("rejecting intervenn", this.selectedRejectionType);
    }

    if (this.rejectionLevel == 'req') {
      if (this.requisition === null) return;
      console.log(this.requisition.Accession, this.rejectionDescription);
      this.requisitionService.rejectRequisition(this.requisition.Accession, this.selectedRejectionType, this.rejectionDescription).subscribe((data: boolean) => {
        this.messageService.add({ severity: 'success', summary: 'Requisition Rejection ', detail: `Successful` });
        this.loadRequisition();
      }, (err) => {
        console.log("rejection error", err);
        this.messageService.add({ severity: 'error', summary: 'Requisition Rejection ', detail: 'Failed: ' + err.error });
        this.loadRequisition();
      });
    } else {
      this.requisitionTestService.reject(this.requisition.Accession, this.rejectRequisitionTestId, this.rejectionDescription, this.selectedRejectionType, 0).subscribe((data: boolean) => {
        this.messageService.add({ severity: 'success', summary: 'Test Rejection ', detail: `Successful` });
        this.loadRequisition();
      }, (err) => {
        this.messageService.add({ severity: 'error', summary: 'Test Rejection ', detail: 'Failed: ' + err.error });
        this.loadRequisition();
      });

    }
  }

  public getMedTek21Data() {
    this.loading = true;
    this.order = {};
    if (this.requisition === null) return;
    this.medtek21Service.getByAccession(this.requisition.Accession).subscribe((data: boolean) => {
      if (data) {
        this.order = data;
        this.orderNotFound = "";
      } else {
        this.order = {};
        this.orderNotFound = "Order was not found in MedTek21";
      }
      this.loading = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Requisition Rejection ', detail: 'Failed: ' + err.error });
      this.order = {};
      this.orderNotFound = "Error retrieving Order from MedTek21";
      this.loading = false;
    });
  }

  public getRequisitionDoc() {
    if (this.requisition === null) return;
    this.medtek21Service.getRequisitionByAccession(this.requisition.Accession).subscribe((response: any) => {
      if (response) {

        let file = new Blob([response], { type: 'application/pdf' });

        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Unable to retrieve requisition PDF ', detail: 'Failed: ' + err.error });
      this.orderNotFound = "Error retrieving OrderDocument from MedTek21";
    });
  }

  setResultComment(rid, comment) {
    this.resultIdForComment = rid;
    this.resultComment = comment;
    this.showResultComment = true;
  }

  saveResultComment() {
    this.requisitionTestService.setResultComment(this.resultIdForComment, this.resultComment).subscribe((data: any) => {
      this.messageService.add({ severity: 'success', summary: 'Comment Saved', detail: `Successful` });
      this.showResultComment = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Comment Save Failed', detail: err.error });
      this.showResultComment = false;
    });
  }

  currentRejection: any = null;

  showUnreject(reject, rejectLevel) {
    this.currentRejection = reject;
    this.rejectionLevel = rejectLevel; // this is Req or ReqTest
    this.showUnrejectDialog = true;
  }

  unreject() {
    this.loading = true;
    this.currentRejection.UnrejectDescription = this.unrejectionDescription;
    if (this.rejectionLevel == "req") { // we are rejecting a Requisition
      this.requisitionService.unrejectRequisition(this.currentRejection).subscribe((data: boolean) => {
        this.messageService.add({ severity: 'success', summary: 'UnReject ', detail: `Successful` });
        this.loadRequisition();
        this.currentRejection = null;
        this.rejectionLevel = null;
        this.showUnrejectDialog = false;
      }, (err) => {
        this.messageService.add({ severity: 'error', summary: 'UnReject ', detail: 'Failed: ' + err.error });
        this.loadRequisition();
        this.currentRejection = null;
        this.rejectionLevel = null;
        this.showUnrejectDialog = false;
      });
    } else { //we are unrejecting a RequisitionTestRejection
      var dto: any = {};
      dto.Accession = this.requisition.Accession;
      dto.RequisitionTestId = this.requisition.Accession;

      this.requisitionTestService.unreject(this.requisition.Accession, this.currentRejection.RequisitionTestId, this.currentRejection.Id, this.currentRejection.Description).subscribe((data: boolean) => {
        this.messageService.add({ severity: 'success', summary: 'UnReject Test', detail: `Successful` });
        this.loadRequisition();
        this.currentRejection = null;
        this.rejectionLevel = null;
        this.showUnrejectDialog = false;
      }, (err) => {
        this.messageService.add({ severity: 'error', summary: 'UnReject Test', detail: 'Failed: ' + err.error });
        this.loadRequisition();
        this.currentRejection = null;
          this.rejectionLevel = null;
        this.showUnrejectDialog = false;
      });
    }
  }

  canUnreject(reject): boolean {
    let rtn: boolean = false;


    return rtn;
  }
  private initReqDto() {
    this.requisition = {
      Accession: '',
      Address1: '',
      Address2: '',
      Bed: '',
      BirthDate: '',
      City: '',
      ClientId: 0,
      ClientName: '',
      CreatedAt: '',
      CreatedBy: '',
      DateCompleted: '',
      DateOfService: '',
      DateReceived: '',
      DateSentToOvation: '',
      Email: '',
      Race: '',
      Ethnicity: '',
      FacilityCode: '',
      FacilityName: '',
      FirstName: '',
      Gender: '',
      HasExceptions: false,
      Id: 0,
      IsAddedToOvation: false,
      IsLIT: false,
      IsMissingReq: false,
      IsNotViable: false,
      IsPatientMismatch: false,
      IsPatientNameMismatch: false,
      IsPatientBirthDateMismatch: false,
      IsPatientSampleMismatch: false,
      PatientSampleObserved: "",
      IsRejected: false,
      LabId: 0,
      LabPanelId: 0,
      labTestAssays: '',
      LabTests: [],
      LastName: '',
      MRN: '',
      OrderSource: '',
      PackageId: 0,
      Phone: '',
      Provider: '',
      ProviderNPI: 0,
      ProviderName: '',
      RequisitionRackHistory: [],
      RequisitionExceptions: [],
      RequisitionICD10: [],
      RequisitionRejections: [],
      RequisitionTests: [],
      RequisitionPays: [],
      RequisitionBilling: { IsTestRequisition: false, IsVipRequisition: false, IsInstitutionalBill: false, IsExpressPay: false, RequisitionBillingClaims:[], IsBillingOnHold: false, Notes:[] },
      Room: '',
      SpecimenCollectedBy: '',
      SpecimenSerialNumber: '',
      SpecimenTypeCode: '',
      SpecimenTypeName: '',
      State: '',
      Station: '',
      Status: '',
      StatusBy: '',
      StatusDate: '',
      StatusLevel: 0,
      UpdatedBy: '',
      Zip: ''
    }
  }

  initStatusDto() {
    this.statusDto = {
      sentDate: '',
      pendingDate: '',
      receivedDate: '',
      processingDate: '',
      reportingDate: '',
      resultedDate: '',
      completedDateArr: [],
      rejectedDateArr: []
    }
  }

  public selectedRejectionTypeChange() {
    var rejectionTypeOtherSelected: boolean = false;

    for(let i = 0; i < this.selectedRejectionType.length; i++) {
      if(this.selectedRejectionType[i] == 7) {  //7 = Other (which also requires a Rejection Comment/Description)
        rejectionTypeOtherSelected = true;
        break;
      }
    }

    this.rejectionCommentRequired = rejectionTypeOtherSelected;
  }

  public selectedRejectionCommentChange() {
    if (this.rejectionSelDescription == "Other") {
      this.rejectionDescription = "";
      this.rejectionCommentOtherRequired = true;
    } else {
      this.rejectionDescription = this.rejectionSelDescription;
      this.rejectionCommentOtherRequired = false;
    }
  }
}

interface StatusDto {
  sentDate: string,
  pendingDate: string,
  receivedDate: string,
  processingDate: string,
  reportingDate: string,
  resultedDate: string,
  completedDateArr: string[],
  rejectedDateArr: string[]
}
